(() => {
  if (window.MDProductDetailsTabs) {
    window.MDProductDetailsTabs.init(document);
    return;
  }

  const init = (scope = document) => {
    const tabLists = [];

    if (scope.matches?.('[data-md-product-tabs]')) tabLists.push(scope);
    scope.querySelectorAll?.('[data-md-product-tabs]').forEach((tabList) => tabLists.push(tabList));

    tabLists.forEach((tabList) => {
      if (tabList.dataset.mdTabsReady === 'true') return;

      const tabs = [...tabList.querySelectorAll('[data-md-product-tab]')];
      if (!tabs.length) return;

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const panel = tabList.closest('.md-product-details__specifications');

      let arrow = panel?.querySelector('.md-product-details__tabs-arrow');
      if (!arrow && panel) {
        arrow = document.createElement('span');
        arrow.className = 'md-product-details__tabs-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '›';
        panel.appendChild(arrow);
      }

      const getRightReserve = () => (mobileQuery.matches ? 72 : 0);

      const updateScrollState = () => {
        if (!mobileQuery.matches) {
          arrow?.classList.remove('is-visible');
          return;
        }

        const isScrollable = tabList.scrollWidth > tabList.clientWidth + 4;
        const isAtEnd = tabList.scrollLeft + tabList.clientWidth >= tabList.scrollWidth - 6;

        arrow?.classList.toggle('is-visible', isScrollable && !isAtEnd);
      };

      const centerTab = (tab) => {
        if (!mobileQuery.matches) return;

        const rightReserve = getRightReserve();
        const visibleWidth = Math.max(1, tabList.clientWidth - rightReserve);
        const tabCenter = tab.offsetLeft + (tab.offsetWidth / 2);
        const targetLeft = tabCenter - (visibleWidth / 2);
        const maxLeft = Math.max(0, tabList.scrollWidth - tabList.clientWidth);
        const left = Math.max(0, Math.min(targetLeft, maxLeft));

        tabList.scrollTo({ left, behavior: 'smooth' });
        window.setTimeout(updateScrollState, 320);
      };

      const activateTab = (tab, moveFocus = false) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;

          const panelId = item.getAttribute('aria-controls');
          const contentPanel = panelId ? document.getElementById(panelId) : null;
          if (contentPanel) contentPanel.hidden = !active;
        });

        centerTab(tab);
        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          activateTab(tabs[nextIndex], true);
        });
      });

      tabList.addEventListener('scroll', updateScrollState, { passive: true });
      window.addEventListener('resize', updateScrollState);
      mobileQuery.addEventListener?.('change', updateScrollState);

      requestAnimationFrame(() => {
        updateScrollState();

        const activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        if (activeTab && mobileQuery.matches) centerTab(activeTab);
      });

      tabList.dataset.mdTabsReady = 'true';
    });
  };

  window.MDProductDetailsTabs = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
